import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  trigger(event) {
    window.dispatchEvent(new CustomEvent(this.data.get("event"), { detail: { element: event.target } }));
  }
}
